import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import NSWRFSImage from "../components/images/nswrfsImage"
import NSWFARImage from "../components/images/nswfarImage"
import HouseFireIcon from "../components/icons/houseFireIcon"
import FireExtinguisherIcon from "../components/icons/fireExtinguisherIcon"
import ListIcon from "../components/icons/listIcon"
import EmergencyNumberImage from "../components/images/emergencyNumberImage"
import FadeIn from "react-fade-in"
import {
  Card,
  CardSubtitle,
  CardFooter,
  CardTitle,
  CardBody,
  CardHeader,
  CardColumns,
} from "reactstrap"
import "./community.css"

export default function Community() {
  return (
    <Layout>
      <SEO title="Community" description="Marsden Park RFS Community Page" />
      <CardColumns>
        <FadeIn>
          <Card>
            <CardHeader>
              <center>
                <ListIcon />
              </center>
              <CardTitle className="home-card-title">
                Bush Survival Plan
              </CardTitle>
            </CardHeader>
            <CardBody>
              <CardSubtitle>
                Four simple steps to get ready for a bushfire:
              </CardSubtitle>
              <ol>
                <li>Discuss what to do if a bushfire threatens your home</li>
                <li>Prepare your home and get it ready for bushfire season</li>
                <li>Know the bush fire alert levels</li>
                <li>
                  Keep all bush fire information numbers, websites and the
                  smartphone app
                </li>
              </ol>
            </CardBody>
            <CardFooter>
              <div> For more information visit:</div>
              <a
                href="https://www.rfs.nsw.gov.au/resources/bush-fire-survival-plan"
                target="_blank"
                rel="noopener noreferrer"
              >
                NSW Rural Fire Service
              </a>
            </CardFooter>
          </Card>
          <Card>
            <CardHeader>
              <a
                href="https://www.rfs.nsw.gov.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <NSWRFSImage />
              </a>
              <CardTitle className="home-card-title">NSW RFS</CardTitle>
            </CardHeader>
            <CardBody>
              <div>
                For more information on major fire updates, the latest news and
                more, visit:
              </div>
              <a
                href="https://www.rfs.nsw.gov.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NSW Rural Fire Service
              </a>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <center>
                <FireExtinguisherIcon />
              </center>
              <CardTitle className="home-card-title">
                Fire Safety Tips
              </CardTitle>
            </CardHeader>
            <CardBody>
              <ul className="home-list">
                <li>
                  Smoke from a fire can leave you confused and unable to see
                </li>
                <li>
                  While asleep, inhaled smoke cannot be smelt and can put you in
                  a deeper sleep
                </li>
                <li>
                  If you have escaped from a home fire, once you get out stay
                  out
                </li>
                <li>
                  Oil, gas or wood heating units may require a yearly
                  maintainenance check
                </li>
              </ul>
            </CardBody>
            <CardFooter>
              For more information visit:
              <br />
              <a
                href="https://www.rfs.nsw.gov.au/resources/factsheets"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rural Fire Service Fact Sheets
              </a>
            </CardFooter>
          </Card>
          <Card>
            <CardBody>
              <EmergencyNumberImage />
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <center>
                <HouseFireIcon />
              </center>
              <CardTitle className="home-card-title">
                Home Fire Safety
              </CardTitle>
            </CardHeader>
            <CardBody>
              <CardSubtitle>
                A few tips to ensure that you and your family are fire safe in
                the home:
              </CardSubtitle>
              <ul className="home-list">
                <li>
                  Ensure that you have an adequate number of smoke alarms which
                  are regularly tested installed
                </li>
                <li>
                  Have a written escape plan in case of emergency and ensure all
                  members of the house know it
                </li>
                <li>
                  Make sure keys to all locked doors are accessible incase you
                  need to escape
                </li>
                <li>
                  Don't overload powerpoints and keep inactive and unused
                  appliances turned off
                </li>
              </ul>
            </CardBody>
            <CardFooter>
              <div> For more information visit:</div>
              <a
                href="https://www.fire.nsw.gov.au/page.php?id=289"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fire and Rescue NSW
              </a>
            </CardFooter>
          </Card>
          <Card>
            <CardHeader>
              <a
                href="https://www.fire.nsw.gov.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <NSWFARImage />
              </a>
              <CardTitle className="home-card-title">Fire and Rescue</CardTitle>
            </CardHeader>
            <CardBody>
              <div>
                For more information on community, building and workplace fire
                safety and more, visit:
              </div>
              <a
                href="https://www.fire.nsw.gov.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fire and Rescue NSW
              </a>
            </CardBody>
          </Card>
        </FadeIn>
      </CardColumns>
    </Layout>
  )
}
